import React from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TypedMemo } from '../../common/types';
import { TrackerProviderMark } from './trackerProviders';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole screen; each part uses its own slice of it */
import styles from './SMLTrackers.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface TrackerMarkProps {
  mark: TrackerProviderMark;
  /** 34px in a list row, 18px in a chip. */
  size: 'row' | 'chip';
}

/** The provider's own colour, so a row is read before it is read. */
const TrackerMarkComponent: React.FC<TrackerMarkProps> = ({ mark, size }) => (
  <span
    className={clsx(styles.mark, size === 'row' ? styles.markRow : styles.markChip)}
    style={{ background: mark.color }}
    aria-hidden
  >
    <FontAwesomeIcon icon={mark.icon} />
  </span>
);

export const TrackerMark = TypedMemo(TrackerMarkComponent);
